import React, { FC } from "react";
import { Description, Icon } from "@evergis/ui";

import { NoLiveSnapshotContainer } from "../styled";

export const NoLiveSnapshot: FC = () => {
  return (
    <NoLiveSnapshotContainer>
      <Icon kind="alert" />
      <Description>Снимок не доступен</Description>
    </NoLiveSnapshotContainer>
  );
};
